import { CheckableFieldComponent } from "./chunk-XZDF54SW.js";
import { Checkbox_default } from "./chunk-IEFRMYRN.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckboxPanel/CheckboxPanel.tsx
import React, { forwardRef } from "react";
import clsx from "clsx";
var CheckboxPanel = forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      name,
      children,
      validation,
      validationMessage,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "children", "validation", "validationMessage", "className"]);
  return /* @__PURE__ */React.createElement(CheckableFieldComponent, {
    id,
    name,
    validation,
    validationMessage,
    className: clsx("pd-checkbox-panel pd-checkbox-panel--primary", className)
  }, /* @__PURE__ */React.createElement(CheckableFieldComponent.Input, __spreadValues({
    ref,
    as: Checkbox_default,
    className: "pd-checkbox-panel__input"
  }, rest)), /* @__PURE__ */React.createElement(CheckableFieldComponent.Wrap, {
    className: "pd-checkbox-panel__wrap"
  }, children));
});
var CheckboxPanel_default = CheckboxPanel;
export { CheckboxPanel_default };